export default __webpack_public_path__ + "static/media/10_photo.59716f6f.jpg";